module.exports = __webpack_public_path__ + "img/input.5fded9cc.svg";